import { partitionStationSections } from '@app/core/stations/partition-station-sections';
import { MinimumStationsGroup } from '@app/core/types/stations';
import { StationStatusListItem } from '@app/modules/logger/screens/status/types';

export interface SharedGroupStatusSection {
  group: MinimumStationsGroup;
  items: StationStatusListItem[];
}

export interface PartitionedStatusSections {
  ownStations: StationStatusListItem[];
  individuallySharedStations: StationStatusListItem[];
  sharedGroupSections: SharedGroupStatusSection[];
}

/**
 * Splits non-favorite statuses into own stations, individually shared stations,
 * and one section per shared group. A shared station that belongs to a shared group
 * is assigned to the first matching group so it is not listed twice.
 */
export function partitionStatusSections(
  nonFavorites: StationStatusListItem[],
  stationsGroups: MinimumStationsGroup[],
): PartitionedStatusSections {
  const { ownStations, individuallySharedStations, sharedGroupSections } = partitionStationSections(
    nonFavorites.map((item) => item.station),
    stationsGroups,
  );

  const itemByStationId = new Map(nonFavorites.map((item) => [item.station.id, item]));

  return {
    ownStations: ownStations
      .map((station) => itemByStationId.get(station.id))
      .filter((item): item is StationStatusListItem => item !== undefined),
    individuallySharedStations: individuallySharedStations
      .map((station) => itemByStationId.get(station.id))
      .filter((item): item is StationStatusListItem => item !== undefined),
    sharedGroupSections: sharedGroupSections.map((section) => ({
      group: section.group,
      items: section.stations
        .map((station) => itemByStationId.get(station.id))
        .filter((item): item is StationStatusListItem => item !== undefined),
    })),
  };
}
